import React from "react";
import { observer } from "mobx-react";
import classnames from "classnames";

import { toDisplayOdd } from "@gp/utility";
import { useRootAppStore } from "@hooks";

import { BettingTips } from "@api-types/bet-booster/BettingTipsType";
import BettingTipsStore from "@state/quick-play-store/BettingTipsStore";

export default observer(function BettingTipQuotaButton(props: {
	tip: BettingTips;
	isInPopup?: boolean;
	store?: BettingTipsStore;
}) {
	const rootStore = useRootAppStore();

	const displayTipValue = toDisplayOdd(props.tip.value);
	const isSelected = rootStore.betSlipStore.isTipSelected(
		props.tip.bettingOfferId
	);

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		e.stopPropagation();

		rootStore.betSlipStore.addRemoveOffer({
			id: props.tip.bettingOfferId,
			keyId: props.tip.bettingOfferKeyId,
			eventId: props.tip.eventId,
			value: props.tip.value,
		});

		if (props.isInPopup) {
			props.store?.deactivatePopup();
		}
	};

	return (
		<>
			<button
				type="button"
				onClick={handleClick}
				className={classnames("card--bbt__quota btn quote--button", {
					"quote quote--button--bbt card--bbt--nowrap__quota":
						!props.isInPopup,
					"btn--med btn--block": props.isInPopup,
					"is-active": isSelected,
				})}
			>
				<strong className="quote--button__odd u-type--center">
					{displayTipValue}
				</strong>
			</button>
		</>
	);
});
